/* eslint-disable @typescript-eslint/no-explicit-any */
import { Canvas, extend, type ThreeToJSXElements } from '@react-three/fiber';
import Experience from './Experience';
import * as THREE from 'three/webgpu';
import { Suspense } from 'react';
import { Leva } from 'leva';
import { Interface } from './components/ui/Interface';
import { SpeedInsights } from '@vercel/speed-insights/react';
import { Analytics } from '@vercel/analytics/react';

declare module '@react-three/fiber' {
  // eslint-disable-next-line @typescript-eslint/no-empty-object-type
  interface ThreeElements extends ThreeToJSXElements<typeof THREE> {}
}

extend(THREE as any);

export const App = () => {
  // const siteUrl = 'https://roys-cozy-place.vercel.app';
  return (
    <>
      {/* <Seo
        title="Roy's Island"
        description='a threejs monthly challenge project'
        canonical='https://roys-cozy-place.vercel.app'
        schemaMarkup={{
          '@context': 'https://schema.org',
          '@type': 'WebSite',
          name: 'Your Site',
          url: 'https://roys-cozy-place.vercel.app',
        }}
        image={`${siteUrl}/img/og-img.png`}
      /> */}
      <Interface />
      <Leva
        theme={{
          sizes: {
            rootWidth: '350px',
          },
        }}
        hidden={true}
      />
      <Canvas
        shadows={'soft'}
        dpr={1.5}
        camera={{
          fov: 15,
          near: 0.1,
          far: 400,
          position: [28, 14, 12],
          //position: [0, 2, 6 * 2],
        }}
        gl={async (props) => {
          const renderer = new THREE.WebGPURenderer({
            antialias: true,
            ...(props as any),
          });

          await renderer.init();
          return renderer;
        }}
      >
        <Suspense>
          <Experience />
        </Suspense>
      </Canvas>
      <SpeedInsights />
      <Analytics />
    </>
  );
};
